import { Component, ChangeDetectionStrategy, output } from '@angular/core';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavbarComponent {
  readonly redirectToWelcome = output<void>();

  redirectToRegistration(): void {
    this.redirectToWelcome.emit();
  }
}
